import { publicListing } from "../constants/actionTypes";

const defaultState = {
  listing: {},
  preloaders: { page: true, messages: false },
  modals: {
    messages: false
  },
  error: {
    message: ""
  }
};

export default function(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case publicListing.SET_LOADING:
      return {
        ...state,
        preloaders: { ...state.preloaders, [payload.section]: payload.isLoading }
      };

    case publicListing.GET_LISTINGS:
      return {
        ...state,
        listing: payload,
        preloaders: {
          ...state.preloaders,
          page: false
        }
      };

    case publicListing.GET_LISTINGS_FAIL:
    case publicListing.ADD_FAVORITES_FAIL:
      return {
        ...state,
        preloaders: {
          ...state.preloaders,
          page: false
        }
      };

    case publicListing.ADD_FAVORITES:
      return {
        ...state,
        listing: {
          ...state.listing,
          bookmarked: true
        },
        preloaders: {
          ...state.preloaders,
          page: false
        }
      };

    case publicListing.REMOVE_FAVORITES:
      return {
        ...state,
        listing: {
          ...state.listing,
          bookmarked: false
        },
        preloaders: {
          ...state.preloaders,
          page: false
        }
      };

    case publicListing.SEND_MESSAGE:
      return {
        ...state,
        preloaders: { ...state.preloaders, messages: false },
        modals: { ...state.modals, messages: false }
      };

    case publicListing.SEND_MESSAGE_FAIL:
      return {
        ...state,
        preloaders: { ...state.preloaders, messages: false },
        error: { ...state.error, message: payload }
      };

    case publicListing.CLEAR_ERROR:
      return {
        ...state,
        error: { ...defaultState.error }
      };

    case publicListing.TOGGLE_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          [payload.modal]: payload.isActive
        }
      };

    default:
      return state;
  }
}
